// F1 C3: recuo progressivo das novas tentativas de carga de histórico depois de uma falha.
// 2 s, 4 s, 8 s, 16 s e depois 30 s por tentativa (o botão "tentar de novo" não espera).
export const RETRY_FIRST_MS = 2000;
export const RETRY_MAX_MS = 30000;

/** Espera antes da tentativa seguinte, para a falha número `attempt` (1, 2, 3...). */
export function nextRetryDelayMs(attempt: number): number {
  const n = Math.max(1, Math.floor(attempt));
  return Math.min(RETRY_MAX_MS, RETRY_FIRST_MS * 2 ** (n - 1));
}
